
import { createSlice } from "@reduxjs/toolkit";

const customSectionReducer = createSlice({
    name: 'customSection',
    initialState: {
        sections: [],
        isFetching: false,
        error: false,
    },

    reducers: {
        // Get All section
        getSectionStart: (state) => {
            state.isFetching = true;
        },
        getSectionSuccess: (state, action) => {
            state.isFetching = false;
            state.sections = action.payload;
        },
        getSectionFailure: (state) => {
            state.isFetching = false;
            state.error = true;
        },

    },
});

export const { getSectionStart, getSectionSuccess, getSectionFailure} = customSectionReducer.actions;
export default customSectionReducer.reducer;